import React from 'react';

import { ETripEvent, IApiFlightTripEvent } from 'detailsv2/structure';

import { AccomodationModal } from './AccomodationModal';
import { ActivityTripEventModalContent } from './TripEventModalContents/Activity';
import { AreaTripEventModalContent } from './TripEventModalContents/Area';
import FlightTripEventModalContent from './TripEventModalContents/Flight';
import { InfoTripEventModalContent } from './TripEventModalContents/Information';
import TransferTripEventModalContent from './TripEventModalContents/Transfer';
import { IEditModalProps } from './types';
import { useEventModal } from './useEventModal';

const EditModal = ({ tripEvent }: IEditModalProps) => {
  const { submitForm } = useEventModal({ tripEvent });

  switch (tripEvent.type) {
    case ETripEvent.Area:
      return <AreaTripEventModalContent tripEvent={tripEvent} onSubmit={submitForm} />;
    case ETripEvent.Activity:
      return <ActivityTripEventModalContent tripEvent={tripEvent} onSubmit={submitForm} />;
    case ETripEvent.Information:
      return <InfoTripEventModalContent tripEvent={tripEvent} onSubmit={submitForm} />;
    case ETripEvent.Accommodation:
      return <AccomodationModal tripEvent={tripEvent} onSubmit={submitForm} />;
    case ETripEvent.Flight:
      return <FlightTripEventModalContent tripEvent={tripEvent as IApiFlightTripEvent} onSubmit={submitForm} />;
    case ETripEvent.Transfer:
      return <TransferTripEventModalContent tripEvent={tripEvent} onSubmit={submitForm} />;
    default:
      return null;
  }
};

export default EditModal;
